import { render, staticRenderFns } from "./Descuento_2.vue?vue&type=template&id=e2085cb4&scoped=true&"
import script from "./Descuento_2.vue?vue&type=script&lang=js&"
export * from "./Descuento_2.vue?vue&type=script&lang=js&"
import style0 from "./Descuento_2.vue?vue&type=style&index=0&id=e2085cb4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2085cb4",
  null
  
)

export default component.exports